<!-- section start -->
<section class="agency blog-sec blog-sidebar single_blog_item">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 order-lg-2 p-0">
                <div class="col-12 blog">
                    <div class="blog-block">
                        <div class="blog-box">
                            <div class="overflow-hidden">
                                <img [defaultImage]="defaultImage" [lazyLoad]="blogData.cover" class="img-fluid blur-up lazyload" [alt]="blogData.title" draggable="false">
                            </div>
                        </div>
                    </div>
                    <div class="blog-text m-t-20" itemscope itemtype="http://schema.org/Blog">
                        <div class="row">
                            <div class="col-12 d-flex flex-row">
                                <div class="mr-3">
                                    <i class="fa fa-clock-o m-r-10" aria-hidden="true"></i>
                                    <h6 class="d-inline-block m-0" itemprop="dateCreated">{{blogData.createdAt | date: 'longDate'}}</h6>
                                </div>
                                <div class="ml-3">
                                    <i class="fa fa-paperclip m-r-10" aria-hidden="true"></i>
                                    <h6 class="d-inline-block m-0" itemprop="author">{{blogData.author}}</h6>
                                </div>
                            </div>
                            <div class="col-12 mt-2">
                                <share-buttons theme="default" [show]="shareablePlatforms.length" [include]="shareablePlatforms" [showText]="true" [size]="-4"></share-buttons>
                            </div>
                        </div>
                        <hr/>
                        <a [routerLink]="['/blog', blogData.code]" [title]="blogData.title">
                            <h1 class="blog-head blog-detail-title" itemprop="name">{{blogData.title}}</h1>
                        </a>
                        <div class="blog-divider"></div>
                        <div class="blog-description" [innerHTML]="blogData.content" itemprop="text">
                            <!-- <p [innerHTML]="blogDetail"></p> -->
                            <!-- <h5>{{blogData.name}}</h5>
                            <h5 class="pull-right">{{blogData.like}} <i class="fa fa-heart-o"></i>{{blogData.comment}} <i
                                    class="fa fa-comments-o"></i>
                            </h5> -->
                        </div>
                    </div>
                    <!-- Comment Sec Start -->
                    <!-- <h3 class="page-header-comment">{{blogData.section}}</h3>
                    <div class="comment-list blog_comment">
                        <div class="comment_sec" *ngFor="let data of blogData.commentSection">
                            <article class="row">
                                <div class="" [ngClass]="data.Id==2?'col-11 offset-1':'col-12'">
                                    <div class="blog_center" [ngClass]="data.Id==2?re_comment:''">
                                        <div>
                                            <figure class="thumbnail">
                                                <img [src]="data.commentImg" alt="">
                                            </figure>
                                        </div>
                                        <div class="blog_user arrow left">
                                            <div class="panel-body">
                                                <div class="text-left">
                                                    <div class="comment-user"><i class="fa fa-user"></i>
                                                        <h6>{{data.commentName}}</h6>
                                                    </div>
                                                    <div class="comment-date"><i class="fa fa-clock-o"></i>
                                                        <h6>{{data.commentDate}}</h6>
                                                    </div>
                                                </div>
                                                <div class="comment-post">
                                                    <p>
                                                        {{data.commentDescription}}
                                                    </p>
                                                </div>
                                                <a href="javascript:void()" class="link-btn"><i class="fa fa-reply"></i>
                                                    {{data.commentReplayTag}}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div> -->
                    <!-- Comment Sec End -->
                </div>
                <!-- <div class="quote_2 comment_form_sec">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 quote_form">
                                <hr />
                                <h3 class="page-header-comment mb-4">Leave you comment :</h3>
                                <form>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label>Name :</label>
                                            <input type="text" class="form-control" placeholder="Enter Your Name"
                                                required="">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="inputEmail4">Email :</label>
                                            <input type="email" class="form-control" id="inputEmail4"
                                                placeholder="Enter Your Email" required="">
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label for="exampleTextarea">Message :</label>
                                            <textarea class="form-control msg_coment" id="exampleTextarea" rows="3"
                                                placeholder="Leave a Comment" required=""></textarea>
                                        </div>
                                    </div>
                                    <a class="btn btn-default primary-btn m-t-20 radius-0" href="javascript:void()">
                                        Post Comment
                                        <span class="con_btn_eff"></span>
                                    </a>
                                </form>
                            </div>
                        </div>
                    </div>
                </div> -->
                <div class="col-12 mt-3 text-center">
                    <share-buttons [show]="shareablePlatforms.length" [include]="shareablePlatforms" [showText]="true" [size]="-4"></share-buttons>
                </div>
                <hr/>
                <h4 class="my-4">{{ 'YouMayAlsoLike' | translate }}</h4>
                <ngx-masonry [useImagesLoaded]="true" class="masonry-grid" class="m-layout">
                    <div ngxMasonryItem class="m-width m-2-col" (load)="updateMasonryLayout = !updateMasonryLayout" *ngFor="let blog of blogService.blogs | slice: 0:6">
                        <div class="blog-agency">
                            <div class="blog-contain">
                                <img [src]="blog.cover" [alt]="blog.title" class="img-fluid" [routerLink]="['/blog', blog.code]" style="cursor: pointer;">
                                <div class="img-container center-content">
                                    <div class="center-content">
                                        <div class="blog-info" itemscope itemtype="http://schema.org/Blog">
                                            <div class="m-b-20">
                                                <div class="center-text">
                                                    <i class="fa fa-clock-o m-r-10" aria-hidden="true"></i>
                                                    <h6 class="m-r-25 font-blog" style="cursor: pointer;" itemprop="dateCreated">{{ blog.createdAt | date: 'longDate' }}</h6>
                                                    <i class="fa fa-paperclip m-r-10" aria-hidden="true"></i>
                                                    <h6 class="font-blog" itemprop="author">{{blog.author}}</h6>
                                                </div>
                                            </div>
                                            <h5 class="blog-head font-600" [routerLink]="['/blog', blog.code]" style="cursor: pointer;" itemprop="name">{{blog.title}}</h5>
                                            <!-- <p class="para2">{{blog.content}}</p> -->
                                            <div class="btn-bottom m-t-20">
                                                <a [routerLink]="['/blog', blog.code]" class="text-uppercase" [title]="blog.title">{{ 'ReadMore' | translate }}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ngx-masonry>
            </div>
            <div class="col-lg-3">
                <app-sidebar [filterByCategory]="filterByCategory"></app-sidebar>
            </div>
        </div>
    </div>
</section>
<!-- section end -->